import React from 'react';
import {connect} from 'react-redux';
import {change, InjectedFormProps, reduxForm} from 'redux-form'
import Repeater from "@Utils/Repeater";
import {CardDisplay} from '../utils/CardDisplay';
import Card from '../utils/Card';
import {AppState} from "@Redux/store";
import validate, {CreateDraftParams} from "./DraftValidate";
import {Dispatch} from "@Redux/type";
import { FormattedMessage } from 'react-intl';
import { Row } from 'reactstrap';
import { defaultMessages } from '@I18n/default';

interface Props {
  onSubmit: () => void
}

const Form: React.FC<FormProps & InjectedFormProps<CreateDraftParams, FormProps>> = ({
                                                                                       onSubmit,
                                                                                       setFormSize,
                                                                                     }) => {
  const sizes = [2, 3, 4, 5, 6, 7, 8, 9, 10];

  const setSize = (size: number) => {
    setFormSize(size);
    onSubmit();
  }

  return (
    <form>
      <h1 className="text-center"><FormattedMessage {...defaultMessages.toolPairingSelectTeamSizeHowMany} /></h1>
      <Row className="justify-content-md-center card-armies">
        <Repeater data={sizes} indexPrefix='size'>
          {
            (item: number) =>
              <Card display={CardDisplay.TEXT} text={item} selectable={true} select={() => setSize(item)}/>
          }
        </Repeater>
      </Row>
    </form>
  );
}

const CreateDraftForm = reduxForm<CreateDraftParams, FormProps>({
  form: 'create_draft',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  validate,
})(Form);

const mapStateToProps = (state: AppState) => ({
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setFormSize: (size: number) => {
    dispatch(change('create_draft', 'size', size));
  }
})

type FormProps = Props &
  ReturnType<typeof mapDispatchToProps>

export default connect(mapStateToProps, mapDispatchToProps)(CreateDraftForm);
